import * as classNames from 'classnames'
import * as React from 'react'

import { reportProductsImpressions } from '../../../../common/analytics/resultAnalytics'
import { isSearchResultMatchesEqual } from '../../../../common/utils/item'
import categories from '../../../../config/sites/categories'
import { ISeoItem } from '../../../../typings/seoMetadata'
import Button from '../../../components/button'
import Dropdown from '../../../components/dropdown'
import ItemPreviewer from '../../../components/itemPreviewer'
import ItemThumbnailCarousel from '../itemThumbnailCarousel'
import SectionDescription from '../sectionDescription'

import { INewestItemsData } from '../../../containers/homePageContainer'

import * as styles from './newestItemSection.module.css'

interface ICategoryConfig {
  name: string
  path: string
}

interface IProps {
  currentSite: string
  metadata: ISeoItem
  fetchNewestItemsByCategory: (category: string) => any
  newestItemsData: INewestItemsData
  videoMuted: boolean
  muteVideo: () => any
}

class NewestItemSection extends React.Component<IProps> {
  public componentDidMount() {
    const { newestItemsData, currentSite } = this.props
    reportProductsImpressions({
      currentSite,
      itemRankOffset: 1,
      items: newestItemsData.items,
      page: 'Homepage',
      section: 'New items'
    })
  }

  public componentDidUpdate(nextProps: IProps) {
    const { newestItemsData, currentSite } = this.props
    if (
      !isSearchResultMatchesEqual(
        nextProps.newestItemsData.items,
        newestItemsData.items
      )
    ) {
      reportProductsImpressions({
        currentSite,
        itemRankOffset: 1,
        items: nextProps.newestItemsData.items,
        page: 'Homepage',
        section: 'New items'
      })
    }
  }

  public render() {
    const {
      currentSite,
      newestItemsData,
      metadata,
      fetchNewestItemsByCategory,
      videoMuted,
      muteVideo
    } = this.props

    const categoriesOptions = [
      {
        name: 'All categories',
        path: 'all'
      },
      ...categories[currentSite]
    ].map((category: ICategoryConfig) => {
      return {
        label: category.name,
        value: category.path
      }
    })

    return (
      <div className={styles.section}>
        <div>
          <h4 className={styles.heading}>{metadata.main_heading}</h4>
        </div>
        <div className={styles.categoriesListDesktop}>
          {categoriesOptions.map((category, index) => {
            const buttonSelected =
              newestItemsData.itemsPendingCategory === category.value ||
              (!newestItemsData.itemsPendingCategory &&
                newestItemsData.itemsCategory === category.value)
            const categoryClassName = classNames(styles.categoryLink, {
              [styles.activeCategoryLink]: buttonSelected
            })
            return (
              <button
                data-test-selector="newestItemSectionCategory"
                className={categoryClassName}
                key={category.value}
                onClick={() => {
                  fetchNewestItemsByCategory(category.value)
                }}
              >
                {category.label}
              </button>
            )
          })}
        </div>
        <div className={styles.categoriesListMobile}>
          <Dropdown
            className={styles.select}
            options={categoriesOptions}
            onChange={event => {
              fetchNewestItemsByCategory(event.target.value)
            }}
            value={
              newestItemsData.itemsPendingCategory ||
              newestItemsData.itemsCategory
            }
          />
        </div>
        <div data-test-selector="newestItemSectionList">
          <ItemThumbnailCarousel>
            {newestItemsData.items.map(item => (
              <ItemPreviewer
                item={item}
                key={item.id}
                videoMuted={videoMuted}
                muteVideo={muteVideo}
              />
            ))}
          </ItemThumbnailCarousel>
        </div>
        <SectionDescription metadata={metadata} HTag="h5" hideOnMobile>
          <Button large fixedWidth href="/category/all?sort=date">
            All New Items
          </Button>
          <Button large fixedWidth href="/page/top_sellers">
            Popular Files
          </Button>
          <Button large fixedWidth href="/category">
            Browse Categories
          </Button>
        </SectionDescription>
        <div
          className={
            newestItemsData.itemsPendingCategory &&
            !newestItemsData.loadingCachedCategory
              ? styles.loading
              : ''
          }
        />
      </div>
    )
  }
}

export default NewestItemSection



// WEBPACK FOOTER //
// ./client/pages/home/newestItemSection/newestItemSection.tsx